import { ArrowUpDown } from 'lucide-react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import FilterMenu from '@/components/ui/filter-menu';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

// Sort options configuration - add new sort types here
const SORT_OPTIONS: { sortBy: string; sortOrder: number; label: string }[] = [
  { sortBy: 'postedAt', sortOrder: -1, label: 'Newest First' },
  { sortBy: 'postedAt', sortOrder: 1, label: 'Oldest First' },
  { sortBy: 'likes', sortOrder: -1, label: 'Most Liked' },
  { sortBy: 'likes', sortOrder: 1, label: 'Least Liked' },
  { sortBy: 'downloads', sortOrder: -1, label: 'Most Downloaded' },
  { sortBy: 'downloads', sortOrder: 1, label: 'Least Downloaded' },
];

function SortControl({ submenu }: { submenu?: boolean }) {
  const { appendSearchParam } = useSearchParamActions();

  const handleSelect = (sortBy: string, sortOrder: number) => {
    appendSearchParam('sortBy', sortBy);
    appendSearchParam('sortOrder', sortOrder.toString());
  };

  return (
    <FilterMenu
      submenu={submenu}
      label={
        <>
          <ArrowUpDown className="h-4 w-4" />
          Sort
        </>
      }
    >
      {SORT_OPTIONS.map((option) => (
        <DropdownMenuItem
          key={`${option.sortBy}-${option.sortOrder}`}
          onClick={() => handleSelect(option.sortBy, option.sortOrder)}
        >
          {option.label}
        </DropdownMenuItem>
      ))}
    </FilterMenu>
  );
}

export default SortControl;
